var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var editor_2d = require("editor-2d");
var colors = require("../colors/colors");
var HandleGridPopupInfo = require("./handleGridPopupInfo.js");

var GridInteractionHandleView = function (iView, gui, idx, handleModel, parentGroup, layers) {
    var self = this;
    this.idx = (idx != undefined ? idx : -1);
    this.gui = gui;
    this.handleModel = handleModel;
    this.interactionModel = this.handleModel.parent();
    this.iView = iView;

    this.cameraModel = this.gui.editorModel.cameraModel();

    // some data models do not have angles
    if (this.handleModel.modelData != undefined && this.handleModel.modelData.angle != undefined) {
        this.angle = this.handleModel.modelData.angle;
    } else {
        this.angle = null;
    }

    this.svgHandle = null;
    this.svgCircle = null;
    this.svgPopup = null;
    this.svgPopupText = null;

    this.initGroups(parentGroup, [layers.interaction, layers.interactionControl], handleModel);

    this.svgGroup = this.getGroupInfo(layers.interaction).svgGroup;
    this.controlGroup = this.getGroupInfo(layers.interactionControl).svgGroup;

    this.HandleGridPopupInfo = new HandleGridPopupInfo(1, this.interactionModel, this.cameraModel, this.gui, this.svgGroup);

    $(this.svgGroup).empty();
    $(this.controlGroup).empty();

    this.handleModel.hidden.onChange(this, function () {
        self.gui.heavyHandler.scheduleHeavy('redraw', self.draw, self, [], self);
    });
    this.handleModel.highlighted.onChange(this, function () {
        self.configHandle();
    }, 10);
    this.cameraModel.viewS.onChange(this, function () {
        self.gui.heavyHandler.scheduleHeavy('update_view', self.configHandle, self, [], self);
    }, 10);
    this.handleModel.pos.onChange(this, function () {
        self.gui.heavyHandler.scheduleHeavy('update_view', self.configHandle, self, [], self);
    }, 10);

    if (this.angle != null && this.angle.onChange != undefined) {
        this.angle.onChange(this, function () {
            self.gui.heavyHandler.scheduleHeavy('rupdateView', self.configHandle, self, [], self);
        }, 10);
    }
    this.handleModel.onDie(this, function () {
        self.emptySvgGroups();
        self.svgHandle = null;
        self.svgCircle = null;
        self.HandleGridPopupInfo.emptySvgGroups();
    }, 10);

    this.draw();
};

lib_core.mixin(GridInteractionHandleView, editor_2d.DrawingElement);

module.exports = GridInteractionHandleView;

GridInteractionHandleView.prototype.configHandle = function() {
    if(!this.handleModel.isAlive()) return;
    if(this.handleModel.hidden()) return;

    var pos = this.handleModel.pos();
    this.size = 8 / this.cameraModel.viewS();
    this.stroke = 1 / this.cameraModel.viewS();

    if(this.svgCircle != null) {
        this.gui.svg.configure(this.svgCircle, {
            cx: pos.x,
            cy: pos.y,
            r: this.size/2,
            'fill' : this.handleModel.highlighted() ? colors.handleFillSelected : colors.handleFill,
            'stroke': colors.handleStroke,
            'strokeWidth': this.stroke,
            'transform': (this.angle != null ?
                (this.interactionModel.angle() ? 'rotate(' + this.interactionModel.angle() + ' ' +
                pos.x + ' ' + pos.y + ')' : '') : '')
        }, true);
    }

    if(this.svgHandle != null) {
        this.gui.svg.configure(this.svgHandle, {
            cx: pos.x,
            cy: pos.y,
            r: this.size/2,
            'strokeWidth': this.stroke
        }, true);
    }

    this.HandleGridPopupInfo.configPopInfo(this.handleModel.highlighted(),
        this.interactionModel,
        false, this.idx);
};

GridInteractionHandleView.prototype.draw = function () {
    var self = this;

    $(this.svgGroup).empty();
    $(this.controlGroup).empty();
    this.HandleGridPopupInfo.emptySvgGroups();

    if(!this.handleModel.isAlive()) return;
    if(this.handleModel.hidden()) return;

    this.c = this.handleModel.pos();
    if(self.c != null) {
        self.size = 8 / self.cameraModel.viewS();
        self.stroke = 1 / self.cameraModel.viewS();
        self.hmX = self.c.getX();
        self.hmY = self.c.getY();

        self.svgCircle = self.gui.svg.circle(self.svgGroup,
            self.c.x,
            self.c.y,
            self.size/2,
            {
                'fill' : self.handleModel.highlighted() ? colors.handleFillSelected : colors.handleFill,
                'stroke': colors.handleStroke,
                'strokeWidth': self.stroke,
                'transform': (self.angle != null ?
                    (self.interactionModel.angle() ? 'rotate(' + self.interactionModel.angle() + ' ' +
                    self.hmX + ' ' + self.hmY + ')' : '') : '')
            }
        );

        // use for debugging, comment out when not needed - please do not delete
        /*if(self.handleModel.handleGridIndex) {
            var hgi = self.handleModel.handleGridIndex();
            var hgiAct = self.handleModel.interactionModel().handleModes.get(hgi-1);
            self.gui.svg.text(self.svgGroup, self.c.x + self.size,
                self.c.y - 2*self.size*(hgiAct%3)/ self.cameraModel.viewS(),
                hgi + "[" + (hgiAct+1) + "]",
                {'font-size': '6pt'});
            hgiAct = hgi = null;
        }*/

        self.svgHandle = self.gui.svg.circle(self.controlGroup,
            self.c.x, self.c.y, self.size/2, { 'strokeWidth': self.stroke });

        self.HandleGridPopupInfo.configPopInfo(self.handleModel.highlighted(),
            self.interactionModel,
            false, self.idx);

        $(self.svgHandle).mousedown(
            function (event) {
                self.onMouseDown(event);
                return false;
            }).hover(
            function(event){
                self.onMouseOver(event);
                return false;
            },
            function(event){
                self.onMouseOut(event);
                return false;
            });
    }
};

GridInteractionHandleView.prototype.onMouseDown = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.HANDLE_MOUSE_DOWN)
        .fromJSEvent(event)
        .element(this.handleModel)
        .data('mouseCoord', this.gui.relativeMouseCoord(event))
        .data('notFocusable', true)
        .data('handleIndex', this.idx) // save which handle this is in the event
        .data('handleType', 2); // 1=normal handle, 2=selection grid handle

    return this.gui.stateMachine.handle(cEvent);
};

GridInteractionHandleView.prototype.onMouseOver = function(event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.HANDLE_MOUSE_OVER)
        .fromJSEvent(event)
        .element(this.handleModel)
        .data('handleIndex', this.idx)
        .data('handleType', 2); // 1=normal handle, 2=selection grid handle
    return this.gui.stateMachine.handle(cEvent);
};

GridInteractionHandleView.prototype.onMouseOut = function(event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.HANDLE_MOUSE_OUT)
        .fromJSEvent(event)
        .element(this.handleModel)
        .data('handleIndex', this.idx)
        .data('handleType', 2); // 1=normal handle, 2=selection grid handle
    return this.gui.stateMachine.handle(cEvent);
};

GridInteractionHandleView.prototype.clickAction = function () {
};

